const kontakt = {
	'contact.title': 'Kontakt',
	'contact.form.subject': 'Pealkiri',
	'contact.form.email': 'Email',
	'contact.form.message': 'Sõnum',
	'contact.form.submit': 'Saada kiri',
	'contact.form.emailSentMessage': 'Kiri saadetud!',
	'contact.form.emailFailedMessage':
		'Kirja saatmine ebaõnnestus, palun proovige uuesti',
	'contact.location': 'Asukoht',
	'contact.address.title': 'Aadress',
	'contact.address': 'Rannaküla , Lääneranna vald, 88228 Pärnu maakond',
	'contact.mobile.title': 'Mobiil',
	'contact.mobile': '(+372) 506 1879',
	'contact.phone.title': 'Telefon',
	'contact.phone': '(+372) 449 6682',
	'contact.email.title': 'E-post',
	'contact.email': 'varblapk@gmail.com',
	'contact.socialmedia': 'Sotsiaalmeedia',
	'contact.distances':
		'Kaugused suurematest linnadest: Pärnu 75 km, Tallinn 150km, Tartu 250 km',
};

export default kontakt;
